"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportFundtDataYearList = exports.reportFundUpdate = exports.reportFundSoftDelete = exports.reportFundRestoreSoftDelete = exports.reportFundReset = exports.reportFundListRestoreSoft = exports.reportFundList = exports.reportFundFindDetails = exports.reportFundFindCurrentFiscal = exports.reportFundFind = exports.reportFundDeleteAll = exports.reportFundDelete = exports.reportFundCreate = exports.reportFundCheckUniqueReset = exports.reportFundCheckUnique = exports.reportDataFundSuccess = exports.reportDataFundError = void 0;
var _fund = require("./fund.constant");
// common success
var reportDataFundSuccess = function reportDataFundSuccess(actionType, data) {
  return {
    type: _fund.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.reportDataFundSuccess = reportDataFundSuccess;
var reportDataFundError = function reportDataFundError(actionType, error) {
  return {
    type: _fund.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * search report fund with params
 * @param payload
 * @returns api response
 * @description this function used to search report fund with params.
 */
exports.reportDataFundError = reportDataFundError;
var reportFundFind = function reportFundFind(data) {
  return {
    type: _fund.actionTypes.FIND_FUND,
    payload: data
  };
};

/**
 * report find fund current fiscal
 * @param payload
 * @returns api response
 * @description this function used to report find fund current fiscal.
 */
exports.reportFundFind = reportFundFind;
var reportFundFindCurrentFiscal = function reportFundFindCurrentFiscal(data) {
  return {
    type: _fund.actionTypes.FIND_CURRENT_FISCAL,
    payload: data
  };
};

/**
 * find report fund details with params
 * @param payload
 * @returns api response
 * @description this function used to find report fund details with params.
 */
exports.reportFundFindCurrentFiscal = reportFundFindCurrentFiscal;
var reportFundFindDetails = function reportFundFindDetails(data) {
  return {
    type: _fund.actionTypes.FIND_DETAILS,
    payload: data
  };
};

/**
 * report fund list with params
 * @param payload
 * @returns api response
 * @description this function used to report fund list with params.
 */
exports.reportFundFindDetails = reportFundFindDetails;
var reportFundList = function reportFundList(data) {
  return {
    type: _fund.actionTypes.LIST,
    payload: data
  };
};

/**
 * report fund create
 * @param payload
 * @returns api response
 * @description this function used to report fund create given inputs.
 */
exports.reportFundList = reportFundList;
var reportFundCreate = function reportFundCreate(data) {
  return {
    type: _fund.actionTypes.CREATE,
    payload: data
  };
};

/**
 * report fund update
 * @param payload
 * @returns api response
 * @description this function used to update report fund given inputs.
 */
exports.reportFundCreate = reportFundCreate;
var reportFundUpdate = function reportFundUpdate(data) {
  return {
    type: _fund.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * report fund delete
 * @param payload
 * @returns api response
 * @description this function used to delete report fund of given params.
 */
exports.reportFundUpdate = reportFundUpdate;
var reportFundDelete = function reportFundDelete(data) {
  return {
    type: _fund.actionTypes.DELETE,
    payload: data
  };
};

/**
 * Check report fund is unique or not
 * @param payload
 * @returns api response
 * @description this function used to check report fund is unique.
 */
exports.reportFundDelete = reportFundDelete;
var reportFundCheckUnique = function reportFundCheckUnique(data) {
  return {
    type: _fund.actionTypes.CHECK_UNIQUE,
    payload: data
  };
};

/**
 * Reset report fund is unique or not
 * @param payload
 * @returns api response
 * @description this function used to reset report fund unique check.
 */
exports.reportFundCheckUnique = reportFundCheckUnique;
var reportFundCheckUniqueReset = function reportFundCheckUniqueReset(data) {
  return {
    type: _fund.actionTypes.CHECK_UNIQUE_RESET,
    payload: data
  };
};

/**
 * report fund report data
 * @param payload
 * @returns api response
 * @description this function used to get report fund report data.
 */
exports.reportFundCheckUniqueReset = reportFundCheckUniqueReset;
var reportFundtDataYearList = function reportFundtDataYearList(data) {
  return {
    type: _fund.actionTypes.YEAR_LIST,
    payload: data
  };
};

/**
 * report fund delete
 * @param payload
 * @returns api response
 * @description this function used to delete report all.
 */
exports.reportFundtDataYearList = reportFundtDataYearList;
var reportFundDeleteAll = function reportFundDeleteAll(data) {
  return {
    type: _fund.actionTypes.DELETE_ALL,
    payload: data
  };
};

/**
 * report reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.reportFundDeleteAll = reportFundDeleteAll;
var reportFundReset = function reportFundReset(data) {
  return {
    type: _fund.actionTypes.RESET,
    payload: data
  };
};
exports.reportFundReset = reportFundReset;
var reportFundSoftDelete = function reportFundSoftDelete(data) {
  return {
    type: _fund.actionTypes.SOFT_DELETE,
    payload: data
  };
};
exports.reportFundSoftDelete = reportFundSoftDelete;
var reportFundRestoreSoftDelete = function reportFundRestoreSoftDelete(data) {
  return {
    type: _fund.actionTypes.RESTORE_SOFT_DELETE,
    payload: data
  };
};
exports.reportFundRestoreSoftDelete = reportFundRestoreSoftDelete;
var reportFundListRestoreSoft = function reportFundListRestoreSoft(data) {
  return {
    type: _fund.actionTypes.LIST_RESTORE_SOFT_DELETE,
    payload: data
  };
};
exports.reportFundListRestoreSoft = reportFundListRestoreSoft;